import React from 'react';

import {Breadcrumb} from './layout/Breadcrumb';
import {BasicButton, PositiveButton} from './layout/Button';
import Container from './layout/Container';
import Contents from './layout/Contents';
import {BasicLink, PositiveLink} from './layout/Link';
import Tab from './layout/Tab';
import TabItem from './layout/TabItem';
import Title from './layout/Tittle';

class MypageLayout extends React.Component<{children?: React.ReactNode}> {
  static Title = Title;
  static Container = Container;
  static Contents = Contents;
  static Tab = Tab;
  static TabItem = TabItem;
  static Breadcrumb = Breadcrumb;

  render() {
    const {children} = this.props;
    return <div>{children}</div>;
  }
}

export default MypageLayout;
export {
  Title,
  Container,
  Contents,
  Tab,
  TabItem,
  Breadcrumb,
  BasicButton,
  PositiveButton,
  BasicLink,
  PositiveLink,
};
